module.exports = __webpack_public_path__ + "img/MicrosoftDynamics365BC.b287c5e1.svg";